import { render, staticRenderFns } from "./eod_list.vue?vue&type=template&id=5b6fdd36&scoped=true&"
import script from "./eod_list.vue?vue&type=script&lang=js&"
export * from "./eod_list.vue?vue&type=script&lang=js&"
import style0 from "./eod_list.vue?vue&type=style&index=0&id=5b6fdd36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6fdd36",
  null
  
)

export default component.exports